import ahnlab from 'assets/icon/partnerLogo/logo_ahnlab.png'
import est from 'assets/icon/partnerLogo/logo_est.png'
import hana from 'assets/icon/partnerLogo/logo_hana.png'
import hanabank from 'assets/icon/partnerLogo/logo_hanabank.png'
import kb from 'assets/icon/partnerLogo/logo_kb.png'
import koreaUniv from 'assets/icon/partnerLogo/logo_korea-univ.png'
import kt from 'assets/icon/partnerLogo/logo_kt.png'
import lg from 'assets/icon/partnerLogo/logo_lg.png'
import nh1 from 'assets/icon/partnerLogo/logo_nh1.png'
import nh2 from 'assets/icon/partnerLogo/logo_nh2.png'
import parking from 'assets/icon/partnerLogo/logo_parking.png'
import sci from 'assets/icon/partnerLogo/logo_SCI.png'
import skp from 'assets/icon/partnerLogo/logo_skp.png'
import skt from 'assets/icon/partnerLogo/logo_skt.png'
import thecheat from 'assets/icon/partnerLogo/logo_thecheat.png'
import tmap from 'assets/icon/partnerLogo/logo_tmap.png'
import woori from 'assets/icon/partnerLogo/logo_woori.png'
import STYLE_GUIDE from 'shared/constants/color'
import styled from 'styled-components'

const PartnerList = [
  { name: 'KB손해보험', src: kb },
  { name: 'KT', src: kt },
  { name: 'LGUP', src: lg },
  { name: 'NH농협은행', src: nh1 },
  { name: 'SCI평가정보', src: sci },
  { name: 'SK텔레콤', src: skt },
  { name: 'SK플래닛', src: skp },
  { name: 'TMAP', src: tmap },
  { name: '고려대학교', src: koreaUniv },
  { name: '농협중앙회', src: nh2 },
  { name: '더치트', src: thecheat },
  { name: '안랩', src: ahnlab },
  { name: '우리은행', src: woori },
  { name: '이스트시큐리티', src: est },
  { name: '파킹박', src: parking },
  { name: '하나은행', src: hanabank },
  { name: '하나카드', src: hana },
]

const PartnerChip = (props) => {
  const { name } = props
  const imgSrc = PartnerList.find((el) => el.name === name)?.src

  return (
    <PartnerChipWrap>
      <img src={imgSrc} alt={name} />
    </PartnerChipWrap>
  )
}

export default PartnerChip

const PartnerChipWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  width: fit-content;
  height: 76px;
  border: 1px solid ${STYLE_GUIDE.COLOR.gray2};
  border-radius: 100px;

  //& > img {
  //    width: auto;
  //    height: 30px;
  //}

  @media screen and (max-width: 1199px) {
    padding: 0 20px;
    height: 40px;

    & > img {
      height: 16px;
    }
  }
`
